import I18n from 'I18n';
export const isTodayOrFuture = value => {
  const today = I18n.moment.userTz().startOf('day');
  const inputDate = I18n.moment.userTz(value).startOf('day');
  return inputDate.isSameOrAfter(today);
};
export const isTodayOrPast = value => {
  const today = I18n.moment.userTz().startOf('day');
  const inputDate = I18n.moment.userTz(value).startOf('day');
  return inputDate.isSameOrBefore(today);
};
export const isTodayBetweenDays = (from, to) => {
  const fromDate = I18n.moment.userTz(from).startOf('day');
  const toDate = I18n.moment.userTz(to).startOf('day');
  const today = I18n.moment.userTz().startOf('day');
  return today.isBetween(fromDate, toDate, undefined, '[]');
};